<template>
  <div>
    <side-bar v-if="isConnected" />
    <!-- <dashboard-content v-bind:class="[isConnected ? isMobile ? 'padding-mobile' : 'padding-regular' : '']" /> -->
    <dashboard-content v-bind:class="[isConnected ? 'padding-regular' : '']" />
  </div>
</template>

<style lang="scss"></style>

<script>
import AuthService from "@/services/AuthService";

// import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
// import MobileMenu from "./MobileMenu.vue";

export default {
  components: {
    // TopNavbar,
    DashboardContent,
    // MobileMenu
  },

  computed: {
    isConnected: function () {
      return AuthService && AuthService.isConnected ? true : false;
    },
    // isMobile() {
    //   return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    // },
  },
};
</script>

<style lang="scss" scoped>
.padding-regular {
  padding-left: 75px;
}
// .padding-mobile {
//   padding-left: 56px;
// }
</style>
